import { METHOD } from "common/hooks";

export const superpotApi = (requestFunc) => {
  return {
    // 슈퍼팟 멤버쉽 입회가능 계약 리스트 조회
    superMemberInfo: {
      key: "superMemberInfo",
      queryFn: (params) =>
        requestFunc(METHOD.GET, `/superpot/memberShipInfos`, params),
    },
    // 슈퍼팟 레벨 조회
    superCourseInfo: {
      key: "superCourseInfo",
      queryFn: (params) =>
        requestFunc(METHOD.GET, `/superpot/courseInfos`, params),
    },
    // 슈퍼팟 입회 정원 조회
    superJoinInfo: {
      key: "superJoinInfo",
      queryFn: (params) =>
        requestFunc(METHOD.GET, `/superpot/joinInfos`, params),
    },
    // Get change progress schedule
    superChangeableSchedule: {
      key: "superChangeableSchedule",
      queryFn: (params) =>
        requestFunc(METHOD.GET, `/superpot/changeableSchedules`, params),
    },
    // Set schedule change
    superChangeSchedule: {
      key: "superChangeSchedule",
      queryFn: (params) =>
        requestFunc(METHOD.POST, `/superpot/schedule/change`, params),
    },
    // Apply Class
    superApplyClass: {
      key: "superApplyClass",
      queryFn: (params) =>
        requestFunc(
          METHOD.POST,
          `/superpot/classes/${params.classSeq}/apply`,
          params
        ),
    },

    // create order
    superpotOrder: {
      key: "superpotOrder",
      queryFn: (params) => requestFunc(METHOD.POST, `/superpot/orders`, params),
    },
    // pay order
    superpotCompleteOrder: {
      key: "superpotCompleteOrder", // 투게더 수업 결제 완료
      queryFn: (params) =>
        requestFunc(METHOD.POST, `/superpot/orders/payment`, params),
    },
    // cancel order
    superPaymentCancel: {
      key: "superPaymentCancel",
      queryFn: (params) =>
        requestFunc(
          METHOD.DELETE,
          `/superpot/orders/${params.orderSeq}/payment-cancel`,
          params
        ),
    },

    // 스마트올 멤버쉽 리스트 조회
    togetherAllSubsMemberInfo: {
      key: "togetherAllSubsMemberInfo",
      queryFn: (params) =>
        requestFunc(METHOD.GET, `/smartall/memberShipInfos`, params),
    },
  };
};
